<template>
  <div v-loading="loading">
    <div class="preview-wrap">
      <div class="container">
        <p class="title">买方交收申请表</p>
        <div class="title-tip">
          <div class="left-box weight">广西康宸世糖贸易有限公司、广西糖网食糖批发市场有限责任公司：</div>
          <div class="right-box">订单编号：{{ orderData.orderCode }}</div>
        </div>
        <table class="my-table" cellspacing="0" cellpadding="0">
          <tr>
            <td colspan="10">
              <span>现向贵司申请提取以下糖源，提货信息如下：</span>
            </td>
          </tr>
          <tr>
            <td colspan="10">
              <span>购货会员名称：</span>
              <span>{{ orderData.buyerName }}</span>
            </td>
          </tr>
          <tr class="center">
            <td style="width: 100px;">
              <span>会员号</span>
            </td>
            <td style="width: 120px;">
              <span>购销计划</span>
            </td>
            <td style="width: 100px;">
              <span>分客户号</span>
            </td>
            <td style="width: 100px;">
              <span>订货单价</span>
            </td>
            <td style="width: 100px;">
              <span>数量（吨）</span>
            </td>
            <td style="width: 80px;">
              <span>等级</span>
            </td>
            <td style="width: 80px;">
              <span>品牌</span>
            </td>
            <td>
              <span>仓库</span>
            </td>
            <td style="width: 80px;">
              <span>升贴水单价</span>
            </td>
            <td style="width: 180px;">
              <span>备注</span>
            </td>
          </tr>
          <!-- 遍历渲染 -->
          <tr class="center" v-for="(item, index) in deliveryDataList" :key="index">
            <td>
              <span>{{ orderData.buyerAccount }}</span>
            </td>
            <td>
              <span>{{ item.contractCode }}</span>
            </td>
            <td>
              <span>{{ item.splitUserAccount }}</span>
            </td>
            <td>
              <span>{{ item.price }}</span>
            </td>
            <td>
              <span>{{ item.quantity }}</span>
            </td>
            <td>
              <span>{{ orderData.grade }}</span>
            </td>
            <td>
              <span>{{ orderData.brandName }}</span>
            </td>
            <td>
              <span>{{ orderData.deliveryAddress }}</span>
            </td>
            <td>
              <span>{{ orderData.areaPrice }}</span>
            </td>
            <td>
              <span>{{ orderData.remark }}</span>
            </td>
          </tr>
          <tr class="center">
            <td>
              <span>合计：</span>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <span>{{ numCount }}</span>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="center">
            <td colspan="10">
              <span>移库选择：</span>
              <span v-for="(item, index) in $key.myOrder.moveWarehouseType" :key="index">
                <label :for="item.id">{{ item.name }}</label>
                <input type="checkbox" :id="item.id" :value="item.id" v-model="moveWarehouseType">
              </span>
            </td>
          </tr>
          <tr class="center">
            <td colspan="10">
              <span>类型选择：</span>
              <!--过滤掉‘其它’-->
              <span v-for="(item, index) in $key.myOrder.deliveryType" :key="index" v-if="item.id !== '50'">
              <label :for="item.id">{{ item.name }}</label>
              <input type="checkbox" :id="item.id" :value="item.id" v-model="deliveryType">
            </span>
              <div style="display: inline">
                <span>其他</span>
                <div style="display: inline-block;">
                  <input type="text" v-model="other" class="other" maxlength="6">
                </div>
              </div>
            </td>
          </tr>
        </table>
        <table class="my-table pick-up-table" cellspacing="0" cellpadding="0">
          <tr v-for="(item, index) in pickUpGoodsDataList" :key="index" :class="{'first-row': index === 0}">
            <td width="140px;">
              <span>提货人{{ index + 1 }}：</span>
              <span>{{ item.consignee }}</span>
            </td>
            <td width="145px;">
              <span>证件名称：</span>
              <span>身份证</span>
            </td>
            <td  width="230px;">
              <span>号码：</span>
              <span>{{ item.papersNo }}</span>
            </td>
            <td width="170px;">
              <span>电话：</span>
              <span>{{ item.phone }}</span>
            </td>
            <td width="140px;">
              <span>车号：</span>
              <span>{{ item.vehicleNo }}</span>
            </td>
            <td width="100px;">
              <span>数量：</span>
              <span>{{ item.pickUpQuantity }}</span>
            </td>
            <td>
              <span>备注：</span>
              <span>{{ item.remark }}</span>
            </td>
          </tr>
        </table>
        <div class="sing-info-wrap">
          <div class="sign">会员签章：</div>
          <div class="date">日期：</div>
        </div>
      </div>
    </div>
    <div class="button-wrap no-print">
      <el-button type="primary" @click="download">下载</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'preview',
  data () {
    return {
      orderData: [], // 订单信息
      deliveryDataList: [], // 交收信息
      pickUpGoodsDataList: [], // 提货信息
      moveWarehouseType: [], // 移仓选择
      deliveryType: [], // 类型选择
      numCount: 0, // 数量合计
      other: '', // 移库选择的其它
      loading: false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 获取交收单数据
    getData () {
      this.loading = true
      const url = this.$API.myOrder.myBuyerDeliveryDetail
      const param = {
        id: this.$route.params.id
      }
      this.$http.post(url, param).then(res => {
        this.loading = false
        this.orderData = res.data.data
        this.moveWarehouseType = [this.orderData.moveWarehouseType] // 移仓选择
        this.deliveryType = [this.orderData.deliveryType] // 类型选择
        this.deliveryDataList = this.orderData.contangoOrderDeliveryDetailList // 交收信息
        this.pickUpGoodsDataList = this.orderData.contangoPickUpInformationList // 提货信息
        if (this.deliveryDataList.length > 1) { // 交收信息多于1条
          this.numCount = this.deliveryDataList.reduce((prev, cur) => { // 把交收列表的数量累加，算出数量累计值
            return prev.quantity + cur.quantity
          })
        } else {
          // 交收信息1条的时候，直接拿数组首位的数量做数量累计值
          this.numCount = this.deliveryDataList.length === 0 ? 0 : this.deliveryDataList[0].quantity
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 下载（即打印）
    download () {
      this.$utils.print()
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-wrap{
    display: flex;
    justify-content: center;
    overflow: hidden;
    .container{
      width: 1200px;
      overflow: hidden;
      color: black;
      margin-top: 40px;
      .title{
        text-align: center;
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .title-tip{
        padding: 0 5px;
        margin-bottom: 8px;
        overflow: hidden;
        .left-box{
          float: left;
        }
        .right-box{
          float: right;
        }
      }
      input[type='checkbox']{
        zoom: 1.5;
        vertical-align: text-top;
        margin: 0 8px;
      }
      .other{
        height: 28px;
        width: 100px;
        border: none;
        border-bottom: 1px solid black;
        margin-left: 5px;
        font-size: 16px;
        line-height: 28px;
      }
      .sing-info-wrap{
        float: right;
        overflow: hidden;
        line-height: 35px;
        margin-top: 40px;
        .sign{
          margin-right: 300px;
        }
      }
    }
    .weight{
      font-weight: bold;
    }
    .my-table {
      border: 1px solid black;
      width: 100%;
    }
    .my-table td {
      padding: 5px;
      border: 1px solid black
    }
    .pick-up-table{
      border-top: none;
      .first-row{
        td{
          border-top: none;
        }
      }
    }
    .center {
      text-align: center
    }
    .select-box {
      display: inline-block;
      width:10px;
      height:10px;
      border:1px solid black;
      position: relative;
    }
    .select-box > span {
      position: absolute;
      left:0;
      top:-5px;
    }
  }
  .button-wrap{
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media print{
    .no-print{
      display: none;
    }
  }
  @page {
    size: A4 landscape;
  }
  @page:right {
    margin-left: 30px;
  }
</style>
